import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MenuItemGroup, PreConfiguredMeal, Restaurant } from '@/models';
import { isGroupOrderRoute } from '@/router';
import { PceLandingPageLoadEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgMealNonBuilder',
})
export default class CmgMealNonBuilder extends Vue {
  watchers: (() => void)[] = [];
  editingMealName = '';
  loading = false;

  @Prop({ required: true, type: Object })
  group!: MenuItemGroup;

  @Prop({ type: Array, required: true })
  preConfiguredMeals!: PreConfiguredMeal[];

  get selectedRestaurant(): Restaurant | null {
    return this.$appStore.state.restaurant.selectedRestaurant;
  }

  mounted() {
    this.watchers.push(this.$appStore.watch(state => state.restaurant.selectedRestaurant, this.onRestaurantSelected, { immediate: true }));

    // If no restaurant has been selected yet, force the user to do so, but not for group order participants
    if (!this.selectedRestaurant && !isGroupOrderRoute(this.$route)) {
      this.$services.ui.setModalVisibility('findAChipotle', true, {
        onClose: () => {
          // If the user *still* hasn't selected a restaurant, nav backwards
          if (!this.selectedRestaurant) {
            this.$router.back();
          } else {
            try {
              this.$services.menu.refreshPreConfiguredMeals(this.selectedRestaurant.restaurantNumber);
            } catch (e: any) {
              this.$services.logger.error('Something went wrong while fetching PreConfiguredMeal data: ', undefined, e);
            }
          }
        },
      });
      this.$services.ui.setModalVisibility('toast', true, {
        body: 'Before you order, we gotta find your Chipotle first.'.toUpperCase(),
        bodyOnly: true,
      });
      Vue.nextTick(() => {
        setTimeout(() => {
          const counter = document.querySelectorAll('.find-a-chipotle-search').length;
          if (counter <= 1) {
            const cfocus = document.querySelectorAll('.find-a-chipotle-search')[0];
            const selection = document.querySelector('[tabindex = "0"]') !== null;
            if (selection) {
              const focusTarget = cfocus.querySelector('[tabindex = "0"]') as HTMLElement;
              focusTarget.focus();
            }
          }
        }, 7000);
      });
    } else if (isGroupOrderRoute(this.$route)) {
      // we need to refresh preconfigured meals list if this is a group order, and it needs to be based of group order's restaraunt ID, not
      // the customer's currently selected restaurant id
      const order = this.$appStore.state.order.pendingGroupOrder;
      if (!order || !order.order.restaurantId) {
        this.$services.logger.unreachable('Group Order does not have a restaurant ID');
        return;
      }
      this.$services.menu.refreshPreConfiguredMeals(order.order.restaurantId);
    }

    this.$services.analytics.send(new PceLandingPageLoadEvent);
  }

  private onRestaurantSelected() {
    this.$services.logger.debug('Refreshing data after restaurant selection...');

    this.refreshPreConfiguredMeals();
  }

  private async refreshPreConfiguredMeals() {
    const restaurant = this.$appStore.state.restaurant.selectedRestaurant;

    try {
      if (restaurant) {
        await this.$services.menu.refreshPreConfiguredMeals(restaurant.restaurantNumber, true);
      }
    } catch (e: any) {
      this.$services.logger.error('Something went wrong while fetching PreConfiguredMeal data: ', undefined, e);
    }
  }

  onMakeItMyOwn(): void {
    this.$services.utils.setIsMakeItMyOwn(true);
  }
}
